import { createContext, useContext } from "react";
export const GameRuntimeContext = createContext({ partySize: 4, fixedParty: false, active: true, localParty: false });
export const useGameRuntime = () => useContext(GameRuntimeContext);
